import "./App.css";
import { Route, Routes } from "react-router-dom";
import Login from "./features/authentication/components/login/login";
import { AppRoutes } from "./features/authentication/types/app-routes";
import Profile from "./features/profile/components/profile/profile";
import Admin from "./features/admin/components/admin/admin";
import { useDispatch, useSelector } from "react-redux";
import ProtectedRoute from "./utils/ProtectedRoute";
import { useEffect, useLayoutEffect, useState } from "react";
import { getProfiles } from "./features/profile/profileSlices";
import { ClipLoader } from "react-spinners";
import ElkanoPdf from "./features/pdf/components/profile/elkano-pdf";
import { updateConnectionTime } from "./features/authentication/userSlices";
const fs = require('fs');

const App = () => {
  const isLoaded = useSelector((state: any) => state.auth.isLoaded);
  if (!isLoaded)
    return (
      <div className="app-wrapper">
        <ClipLoader color={"#EF936C"} loading={true} size={100} />
      </div>
    );
  else return <App2 />;
};

const App2 = () => {
  const dispatch: Function = useDispatch();
  const user = useSelector((state: any) => state.auth.user);
  const isAuthenticated = useSelector(
    (state: any) => state.auth.isAuthenticated
  );
  const isAdmin = user?.admin || false;
  const adminFallBack = isAuthenticated ? AppRoutes.HOME : AppRoutes.LOGIN;
    useEffect(() => {
    dispatch(getProfiles());
    if(!user) return;
    const interval = setInterval(() => {
      dispatch(updateConnectionTime(user?.uid,1));
    }, 60000);
    return () => clearInterval(interval);
  },[user]);

  return (
    <div className="App">
      <Routes>
        <Route path={AppRoutes.LOGIN} element={<Login />} />
        <Route
          path={AppRoutes.HOME}
          element={
            <ProtectedRoute
              fallBack={AppRoutes.LOGIN}
              condition={isAuthenticated}
            >
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path={AppRoutes.ADMIN}
          element={
            <ProtectedRoute fallBack={adminFallBack} condition={isAdmin}>
              <Admin />
            </ProtectedRoute>
          }
        />
        <Route
          path={AppRoutes.PDF}
          element={
            <ProtectedRoute
              fallBack={AppRoutes.LOGIN}
              condition={isAuthenticated}
            >
              <ElkanoPdf />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
};

export default App;
